import * as R from 'ramda';

const GetNavItem = (state: any) => R.pathOr('', ['nav', 'nav'], state);
const GetNavHeight = (state: any) => R.pathOr('', ['nav', 'height'], state);
const GetHeaderNav = (state: any) => R.pathOr('', ['nav', 'headerNav'], state);
const GetSaveFunction = (state: any) => R.pathOr('', ['nav', 'saveFunction'], state);

const selectors = {
  GetNavItem,
  GetNavHeight,
  GetHeaderNav,
  GetSaveFunction
}

export default selectors
